/* src/app/modal/modal.component.scss */
.bg {
  z-index: 999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.7);
}
.window {
  position: absolute;
  left: calc(50% - 200px);
  top: calc(50% - 200px);
  z-index: 1000;
  width: calc(100% - 40px);
  max-width: 440px;
  height: 400px;
  min-width: 320px;
  min-height: 338px;
  background-color: #fff !important;
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
/*# sourceMappingURL=modal.component.css.map */
